import { render, staticRenderFns } from "./AAvatar.vue?vue&type=template&id=0384daea&scoped=true&"
import script from "./AAvatar.vue?vue&type=script&lang=js&"
export * from "./AAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0384daea",
  null
  
)

export default component.exports